import {
	animations,
	STAGGER_DELAY,
	TRANSITION_DURATION,
} from 'constants/motion';

type Animation = keyof typeof animations;

export function getAnimationProps(animation: Animation, delay: number) {
	return {
		initial: 'hidden',
		animate: 'visible',
		variants: animations[animation],
		transition: {
			duration: TRANSITION_DURATION,
			delay: delay * STAGGER_DELAY,
		},
	};
}
